import { useCoreSelector } from '../../CoreStore';

export const useInitializationSlice = {
  getAreBlockingResourcesReady: (): boolean =>
    useCoreSelector(({ initialization }) => initialization.areBlockingResourcesReady),
  getIsReadyToRender: (): boolean => useCoreSelector(({ initialization }) => initialization.isReadyToRender),
  getIsLayoutRendered: (): boolean => useCoreSelector(({ initialization }) => initialization.isLayoutRendered),
  getError: (): Error | null => useCoreSelector(({ initialization }) => initialization.error),
};
